import { render, staticRenderFns } from "./StudentsExams.vue?vue&type=template&id=6b3b6758&scoped=true&"
import script from "./StudentsExams.vue?vue&type=script&scoped=true&lang=js&"
export * from "./StudentsExams.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./StudentsExams.vue?vue&type=style&index=0&id=6b3b6758&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3b6758",
  null
  
)

export default component.exports